import { Injectable } from '@angular/core';
import { GtmData } from '../interfaces/gtm.interface';
import { EventGTM, EventCategory } from '../enum/gtm.enum';
import { AuthenticationService } from '@core-argos-angular-artifact/core';

declare let window: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor(private readonly authService: AuthenticationService) {}

  sendError(typeError: string, label: string, extraInfo?: any): void {
    this.sendGTM(
      EventGTM.ERROR,
      EventCategory.ERROR,
      typeError,
      label,
      extraInfo
    );
  }

  sendLogin(): void {
    this.sendGTM(
      EventGTM.LOGIN,
      EventCategory.LOGIN,
      'UserLoginCompleted',
      this.getUserId()
    );
  }

  private sendGTM(
    analyticsEvent: string,
    analyticsCategory: EventCategory,
    eventAction: string,
    analyticsLabel: string,
    extraInfo = {}
  ): void {
    const gtmData = {
      userId: this.getUserId(),
      event: analyticsEvent,
      eventCategory: analyticsCategory,
      eventAction,
      eventLabel: analyticsLabel
    } as GtmData;

    window.dataLayer.push(Object.assign(gtmData, extraInfo));
  }

  private getUserId(): string {
    return this.authService.isAuthenticated()
      ? this.authService.getTokenParsed().sub
      : undefined;
  }
}
